/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-stock-indent.reducer';

export const PharmacyStockIndentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyStockIndentEntity = useAppSelector(state => state.pharmacyStockIndent.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyStockIndentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.detail.title">PharmacyStockIndent</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.id}</dd>
          <dt>
            <span id="indentStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.indentStatus">Indent Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.indentStatus}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.timestampEntry}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.modifiedById}</dd>
          <dt>
            <span id="fulfilledById">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.fulfilledById">Fulfilled By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.fulfilledById}</dd>
          <dt>
            <span id="pharmacyAddedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.pharmacyAddedByType">Pharmacy Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.pharmacyAddedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.modifiedByType}</dd>
          <dt>
            <span id="fulfilledByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.fulfilledByType">Fulfilled By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.fulfilledByType}</dd>
          <dt>
            <span id="indentFor">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.indentFor">Indent For</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.indentFor}</dd>
          <dt>
            <span id="indentNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.indentNumber">Indent Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentEntity.indentNumber}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.requestingPharmacy">Requesting Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockIndentEntity.requestingPharmacy ? pharmacyStockIndentEntity.requestingPharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndent.fulfillingPharmacy">Fulfilling Pharmacy</Translate>
          </dt>
          <dd>{pharmacyStockIndentEntity.fulfillingPharmacy ? pharmacyStockIndentEntity.fulfillingPharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-stock-indent" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-stock-indent/${pharmacyStockIndentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyStockIndentDetail;
